
import _once from "lodash/once"
import URI from "urijs"

import DataRetriever from "app/data_retriever"

const get_use_google_cn_maps = _once(() => {
  return URI(window.location.href).search().indexOf("force_map_tile=google_cn") !== -1
})
const get_use_baidu_maps = _once((): boolean => {
  return !get_use_google_cn_maps() && !!DataRetriever.get("display-baidu-maps")
})


export default {
  get_use_google_cn_maps,
  get_use_baidu_maps,
}
